import Breadcrumbs from '@components/breadcrumbs/Breadcrumbs'
import styles from 'styles/BreadcrumbBar.module.css'

const BreadcrumbBar = ({ children }) => (
    <div className={`container ${styles.container}`}>
        <div className={styles.bar}>
            <Breadcrumbs />
        </div>

        <div className={styles.actions}>
            { children }
        </div>
    </div>
)

export default BreadcrumbBar